import {useCallback,useEffect,useRef,useState} from 'react';
import {useAuth} from '@cap4/auth';
import {api,ApiError,message} from './api';
import {queryCache} from './queryCache';

export function useQuery<T>(operation:string,input:unknown,enabled=true,loader?:(input:any)=>Promise<T>){
 const {user}=useAuth(), serialized=JSON.stringify(input);
 const key=JSON.stringify([user?.id,operation,serialized]), active=enabled&&!!user;
 const [state,setState]=useState<{key:string;data?:T;error:string;fetching:boolean}>(()=>({key,data:queryCache.peek<T>(key).data,error:'',fetching:active}));
 const [revision,setRevision]=useState(0), force=useRef(false);
 const reload=useCallback(()=>{force.current=true;setRevision(v=>v+1)},[]);
 useEffect(()=>{
   if(!active)return;
   const unsubscribe=queryCache.subscribe(event=>{
     if(event==='invalidate')reload();
     else setState({key,data:undefined,error:event==='denied'?'Adgangen er ændret. Hent indholdet igen.':'',fetching:false});
   });
   const refresh=()=>{if(document.visibilityState==='visible')reload()};
   window.addEventListener('focus',refresh);document.addEventListener('visibilitychange',refresh);
   const timer=setInterval(refresh,30_000);
   return()=>{unsubscribe();clearInterval(timer);window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',refresh)};
 },[active,key,reload]);
 useEffect(()=>{
   if(!active)return;
   let alive=true;const epoch=queryCache.sessionEpoch;
   const refresh=force.current;force.current=false;
   const cached=queryCache.peek<T>(key);
   setState(previous=>({key,data:cached.data??(previous.key===key?previous.data:undefined),error:'',fetching:refresh||!cached.fresh}));
   queryCache.read(key,()=>loader?loader(JSON.parse(serialized)):api<T>(operation,JSON.parse(serialized)),refresh)
     .then(data=>{if(alive&&epoch===queryCache.sessionEpoch)setState({key,data,error:'',fetching:false})})
     .catch(error=>{if(alive)setState(previous=>({key,data:epoch!==queryCache.sessionEpoch||error instanceof ApiError&&error.code==='forbidden'?undefined:previous.key===key?previous.data:undefined,error:message(error),fetching:false}))});
   return()=>{alive=false};
 },[key,operation,serialized,active,revision,loader]);
 const current=state.key===key?state:{key,data:queryCache.peek<T>(key).data,error:'',fetching:active};
 return{data:active?current.data:undefined,error:active?current.error:'',loading:active&&current.data===undefined&&current.fetching,refreshing:active&&current.data!==undefined&&current.fetching,reload};
}
